import { Component, OnInit , ViewEncapsulation} from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { TFMService } from 'app/mock-api/tfm.service';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { CarouselAnimationEffect, CarouselComponent, CarouselModule, CarouselButtonVisibility, CarouselAllModule } from '@syncfusion/ej2-angular-navigations';
import { SlickCarouselModule } from 'ngx-slick-carousel';



import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { RouterLink } from '@angular/router';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { Meta, Title } from '@angular/platform-browser';


@Component({
  selector: 'app-destination-list-type02',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [MatIconModule, MatStepperModule, CarouselModule, ButtonModule, SlickCarouselModule, CarouselAllModule, CarouselModule, NgFor, RouterLink, HeadingSectionType01Component],
  templateUrl: './destination-list-type02.component.html',
  styleUrls: ['./destination-list-type02.component.scss']

})
export class DestinationListType02Component implements OnInit {
  public carouselAnimation: CarouselAnimationEffect = 'Fade';

  public view: any = {
    
  };

  constructor(private _tfmService: TFMService,private title: Title, private metaService: Meta) { 

    this._tfmService.getDestinations().then(res => {
      this.view.destinations = res;
      this.view.destinations.forEach(destination => {
          // Set title for each destination
          this.title.setTitle(`${destination.seo.title} - ${destination.name}`);

          // Set description & keywords for each destination
          this.metaService.updateTag({ name: 'description', content: destination.metaDescription });
          this.metaService.updateTag({ name: 'keywords', content: destination.seo.keywords });
      });
    });

  }

  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this._tfmService.log(this.view);

    });
  }
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }
  // addSlide() {
  //   this.slides.push({img: "http://placehold.it/350x150/777777"})
  // }
  
  // removeSlide() {
  //   this.slides.length = this.slides.length - 1;
  // }
  
  slickInit(e) {
    // this._tfmService.log('slick initialized');
  }
  
  breakpoint(e) {
    // this._tfmService.log('breakpoint');
  }
  
  afterChange(e) {
    // this._tfmService.log('afterChange');
  }
  
  beforeChange(e) {
    // this._tfmService.log('beforeChange');
  }

}
